import { Pipe, type PipeTransform } from '@angular/core';
import { isEmptyString, isNil } from '@pct-ts/typeguard';

@Pipe({
  name: 'withLang',
})
export class WithLangPipe implements PipeTransform {
  transform(prefix: string | null | undefined, language: string | null | undefined): string {
    if (isNil(prefix) || isEmptyString(prefix)) {
      return '';
    }

    if (isNil(language) || isEmptyString(language)) {
      return prefix;
    }

    return `${prefix}-${language}`;
  }
}
